import { render } from "./EditWaiterView.vue?vue&type=template&id=7f8f90e0"
import script from "./EditWaiterView.vue?vue&type=script&lang=js"
export * from "./EditWaiterView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__